
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class POStatusCard extends Vue {
  @Prop({ required: true }) status!: string;
  @Prop({ required: true }) label!: string;
  @Prop({ required: true }) count!: number;
  @Prop({ required: true }) color!: string;
  @Prop({ required: true }) icon!: string;
  @Prop() trend?: number;
  @Prop() sparklineData?: number[];
  @Prop({ default: false }) loading!: boolean;

  width = 100;

  get trendColor() {
    if (!this.trend) return 'grey';
    // For canceled and overdue, increase is bad
    if (this.status === 'canceled' || this.status === 'overdue') {
      return this.trend > 0 ? 'error' : 'success';
    }
    // For other statuses, increase is generally good
    return this.trend > 0 ? 'success' : 'error';
  }

  get trendIcon() {
    if (!this.trend) return '';
    return this.trend > 0 ? 'mdi-arrow-up' : 'mdi-arrow-down';
  }

  get sparklinePoints() {
    if (!this.sparklineData || this.sparklineData.length === 0) return '';
    
    const max = Math.max(...this.sparklineData);
    const min = Math.min(...this.sparklineData);
    const range = max - min || 1;
    
    return this.sparklineData
      .map((value, index) => {
        const x = (index / (this.sparklineData!.length - 1)) * this.width;
        const y = 20 - ((value - min) / range) * 18; // Invert y-axis, leave margin
        return `${x},${y}`;
      })
      .join(' ');
  }

  handleClick() {
    this.$emit('click', this.status);
  }
}
